module.exports = __webpack_public_path__ + "img/chillo-brisal.5597d915.jpg";